import Footer from '../../components/Footer';
import { Header } from '../../components/Header';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { Container, GamesContainer, Row } from './styles';
import { Card } from './components/Card';
import { useEffect, useState } from 'react';
import { apiPHP } from '../../services/api';

interface DifficultyProps {
  nome: string;
  id: number;
}

interface TournamentProps {
  id: number;
  foto: string;
  nome: string;
  edition: string;
  createdAt: string;
  dificuldades: DifficultyProps;
}

export const Tournaments: React.FC = () => {
  const [tournaments, setTournaments] = useState<TournamentProps[]>([]);

  useEffect(() => {
    const getTournaments = async () => {
      const response = await apiPHP.get('/jogo/torneios');

      setTournaments(response.data);
    };

    getTournaments();
  }, []);

  return (
    <Container>
      <Header />
      <GamesContainer>
        <Row>
          <h2>{tournaments.length} Torneios em andamento.</h2>
          <div>
            {tournaments.map((tournament) => (
              <Card
                key={tournament.id}
                id={tournament.id}
                level={tournament.dificuldades.nome}
                img={tournament.foto}
                name={tournament.nome}
                edition={tournament.edition}
              />
            ))}
          </div>
        </Row>
      </GamesContainer>
      <Footer />
    </Container>
  );
};
